import { render } from "./ManageAnsible.vue?vue&type=template&id=4079f4a8&scoped=true"
import script from "./ManageAnsible.vue?vue&type=script&lang=js"
export * from "./ManageAnsible.vue?vue&type=script&lang=js"

import "./ManageAnsible.vue?vue&type=style&index=0&id=4079f4a8&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4079f4a8"]])

export default __exports__